export default __webpack_public_path__ + "static/media/CapitaSpringAnalysis.png?.8bcc6455";